import { IndexApiSet, useIndexApi } from 'utils/network/api_hooks'
import { CraifHttpClient } from '../utils/network/axios'
import { PagingResponse } from 'entities'

type ShipmentTaskItemTemplate = {
    id: number
    app_user_id: number
    name: string
    created_at: string
    updated_at: string
}

type ShipmentTaskItemTemplatesResponse = PagingResponse & {
    results: ShipmentTaskItemTemplate[]
}

export function useFetchShipmentTaskItemTemplatesApi(): IndexApiSet<ShipmentTaskItemTemplatesResponse> & { execute: () => void } {
    const apiPath = 'shipment_task_item_templates/'
    const api = useIndexApi<ShipmentTaskItemTemplatesResponse>(new CraifHttpClient(), {
        initialResponse: { count: 0, results: [] },
        initialState: { page: 1, perPage: 9999 },
    })

    const execute = (): void => {
        api.execute(apiPath)
    }

    return { ...api, execute }
}